
import KlarnaWidget from '~/components/shop/KlarnaWidget.vue'
export default {
  name: 'Klarna',
  components: { KlarnaWidget },
  nuxtI18n: {
    paths: {
      en: '/klarna',
      it: '/klarna',
      de: '/klarna'
    }
  },
  head() {
    return {
      title: this.$t('shop.klarna.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('shop.klarna.description')
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content:
            'https://images.prismic.io/vitesy/5a91dda0-914e-4f55-bdba-f871d35cb97a_launching-soon-bg.jpg?auto=compress,format',
        },
        { hid: 'robots', name: 'robots', content: 'noindex, nofollow' },
      ]
    }
  },
}
